<template>
  <div>
    <el-dialog
        class="model-edit"
        title="相关订单"
        v-if="adminVisible"
        width="950px"
        :visible.sync="adminVisible"
        :close-on-click-modal="false"
        :before-close="adminVisibleClose"
      >
      <el-table
          :row-key="(row) => row.id"
          :data="adminList"
          highlight-current-row
          v-loading="userLoading"
          style="width: 100%"
          ref="userList"
        >
        
          </el-table-column>
          <el-table-column prop="productName" label="产品名称" min-width="130">
          </el-table-column>
          <el-table-column
            prop="purchaseMonth"
            label="购买时长(月)"
            min-width="100"
            xshow-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="purchaseNum"
            label="购买数量"
            min-width="120"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="singlePrice"
            label="单价(元)"
            min-width="160"
            show-overflow-tooltip
          >
          </el-table-column>
      </el-table>
      <div style="height:30px"></div>
    </el-dialog>
  </div>
</template>
<script>
import { API__code, API_Auth} from '../../../api/index.js';
export default {
  props:{
    adminVisible:{
      type:Boolean,
      default:false
    },
    authProductId:{
      type:String,
      default:''
    }
  },
  data(){
    return{
        userSelection:[],
        adminList:[],
        userLoading:false,
        orderLoading:false,
        token:'',
        checkCode:''
    }
  },
  watch:{
    
  },
  mounted(){
    this.getCookie();
    this.getCompanyManage();
  },
  methods:{
    //读取cookie
    getCookie: function() {
        if (document.cookie.length > 0) {
            var arr = document.cookie.split('; ');
            for (var i = 0; i < arr.length; i++) {
                var arr2 = arr[i].split('=');
                if (arr2[0] == 'dnnyptadmin_token') {
                    this.token = arr2[1];
                } else if (arr2[0] == 'dnnyptadmin_checkCode') {
                    this.checkCode = arr2[1];
                } 
            }
        }
    },
    adminVisibleClose(){
      this.$emit("adminVisibleClose")
    },
    getCompanyManage(id) {
      var param = {
        authProductId: this.authProductId,
        token:this.token,
        checkCode:this.checkCode,
      };
      this.userLoading = true;
      API_Auth.getDetailByAuthProductId(param).then((res) => {
        if (res.data.code == 200) {
          var list = JSON.parse(res.data.data.product);
          console.log(list);
          this.adminList = list;
        }
        this.userLoading = false;
      });
    }
  }
}
</script>
<style scoped lang="scss">

</style>


// WEBPACK FOOTER //
// detail.vue?73718280